<template>
  <div>
    <button
      type="button"
      @click="openHandle"
      class="additional-info"
      :class="{ isAdditionalInfoOpened: isAdditionalInfoOpened }"
    >
      {{ t('Additional Information') }}
      <ui-chevron class="ml-4" color="inherit" :open="isAdditionalInfoOpened"></ui-chevron>
    </button>
    <div v-if="isAdditionalInfoOpened" class="additional-info__text">
      <p>
        {{
          t(
            '*If 3DS security is enabled for your card you will see the payment window again for additional authorization. In the appeared window click on Confirm 3DS and pay to access the BeMob panel',
          )
        }}
      </p>
      <p>
        {{ t('For assistance click on') }} <a @click="openLiveSupport">{{ t('Live Support') }}</a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n, useIntercom } from '@/composables';

const { t } = useI18n();
const { openLiveSupport } = useIntercom();

const isAdditionalInfoOpened = ref(false);

const openHandle = () => {
  isAdditionalInfoOpened.value = !isAdditionalInfoOpened.value;
};
</script>

<style lang="scss" scoped>
.additional-info {
  color: var(--color-green);
  font-size: 16px;
  width: 100%;
  align-items: center;
  font-weight: bold;
  border-bottom: 1px solid var(--color-gray10);
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.additional-info__text {
  padding-top: 10px;
}
</style>
